enum RequestMethod {
  "GET",
  "POST",
  "PUT",
  "DELETE",
  "PATCH",
}

export default RequestMethod;
